import {
  IconAbacus,
  IconCalculator,
  IconCalendarTime,
  IconDeviceTablet,
  IconId,
  IconList,
  IconReport,
  IconRouteSquare,
  IconStackBack,
  IconTicket,
  IconUsers,
} from '@tabler/icons-react';
import { Badge, Menu, MenuProps } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { terminalsAppRoute } from 'app/router/routes';

import { UPermissionsName } from '../domains/access/core/permissions';
import { useUserProfileStore } from '../domains/profile/features/user-profile-data';
// import { withPerm } from 'app/railways/domains/access/features/permissions/with-perm';

import { appRoute } from '../router/routes';

const defaultOpenKeys = [
  'passengers',
  'tickets',
  'trips',
  'reports',
  'tariffs',
  'tariff-zones',
  'tariff-profiles',
  'routes',
];

// const SubMenu = withPerm(Menu.SubMenu);
// const SubMenu = Menu.SubMenu;
// const MenuItem = withPerm(Menu.Item);
// const MenuItem = Menu.Item;

const menuItems: ({
  withPerm,
}: {
  withPerm: (perm: UPermissionsName, item: ItemType) => ItemType | null;
}) => MenuProps['items'] = ({ withPerm }) => [
  withPerm('PERM_TICKET_READ', {
    key: 'tickets',
    label: 'Билеты',
    icon: <IconTicket size="16px" stroke="2" />,
    children: [
      withPerm('PERM_TICKET_ORDER_READ', {
        key: 'tickets-operations',
        label: (
          <Link to={appRoute.TICKETS.ORDERS.path}>
            <Badge status="default" text="Заказы" />
          </Link>
        ),
      }),
      withPerm('PERM_TICKET_READ', {
        key: 'all-tickets',
        label: (
          <Link to={appRoute.TICKETS.REPORT.path}>
            <Badge status="default" text="Все билеты" />
          </Link>
        ),
      }),
    ],
  }),
  withPerm('PERM_REPORT_TEMPLATE_READ', {
    key: 'reports',
    label: 'Отчеты',
    icon: <IconReport size="16px" stroke="2" />,
    children: [
      withPerm('PERM_REPORT_TEMPLATE_READ', {
        key: 'reports-all',
        label: (
          <Link to={appRoute.REPORTS.path}>
            <Badge status="default" text="Все отчеты" />
          </Link>
        ),
      }),
      withPerm('PERM_REPORT_TEMPLATE_CREATE', {
        key: 'tickets-report',
        label: (
          <Link to={appRoute.REPORTS.ADD.path}>
            <Badge status="default" text="Добавить отчет" />
          </Link>
        ),
      }),
    ],
  }),
  withPerm('PERM_ROUTE_TRIP_READ', {
    key: 'trips',
    label: 'Рейсы',
    icon: <IconCalendarTime size="16px" stroke="2" />,
    children: [
      withPerm('PERM_ROUTE_TRIP_READ', {
        key: 'trips-all',
        label: (
          <Link to={appRoute.TRIPS.path}>
            <Badge status="default" text="Все рейсы" />
          </Link>
        ),
      }),
      {
        key: 'wagon-scheme',
        label: (
          <Link to={appRoute.WAGON_SCHEMES.path}>
            <Badge status="default" text="Схемы вагонов" />
          </Link>
        ),
      },
      {
        key: 'train-types',
        label: (
          <Link to={appRoute.TRAIN_TYPES.path}>
            <Badge status="default" text="Типы составов" />
          </Link>
        ),
      },
    ],
  }),
  withPerm('PERM_TARIFF_READ', {
    key: 'tariffs',
    label: 'Тарифы',
    icon: <IconAbacus size="16px" stroke="2" />,
    children: [
      withPerm('PERM_TARIFF_READ', {
        key: 'tariffs-all',
        label: (
          <Link to={appRoute.TARIFFS.path}>
            <Badge status="default" text="Все виды тарифов" />
          </Link>
        ),
      }),
      withPerm('PERM_TARIFF_READ', {
        key: 'tariff-prices',
        label: (
          <Link to={appRoute.TARIFF_PRICES.path}>
            <Badge status="default" text="Базовые цены" />
          </Link>
        ),
      }),
    ],
  }),
  withPerm('PERM_TARIFF_PROFILE_READ', {
    key: 'tariff-profiles',
    label: 'Профили тарифов',
    icon: <IconCalculator size="16px" stroke="2" />,
    children: [
      withPerm('PERM_TARIFF_PROFILE_READ', {
        key: 'tariff-profiles-all',
        label: (
          <Link to={appRoute.TARIFF_PROFILES.path}>
            <Badge status="default" text="Все профили" />
          </Link>
        ),
      }),
      withPerm('PERM_TARIFF_PROFILE_CREATE', {
        key: 'tariffs-all-add',
        label: (
          <Link to={appRoute.TARIFF_PROFILES.ADD.path}>
            <Badge status="default" text="Добавить профиль" />
          </Link>
        ),
      }),
    ],
  }),
  {
    key: 'tariff-zones',
    label: 'Тарифные зоны',
    icon: <IconStackBack size="16px" stroke="2" />,
    children: [
      {
        key: 'tariff-zones-all',
        label: (
          <Link to={appRoute.TARIFF_ZONES.path}>
            <Badge status="default" text="Все тарифные зоны" />
          </Link>
        ),
      },
    ],
  },
  withPerm('PERM_ROUTE_READ', {
    key: 'routes',
    label: 'Маршруты',
    icon: <IconRouteSquare size="16px" stroke="2" />,
    children: [
      {
        key: 'routes-all',
        label: (
          <Link to={appRoute.ROUTES.path}>
            <Badge status="default" text="Все маршруты" />
          </Link>
        ),
      },
    ],
  }),
  withPerm('PERM_PERSON_READ', {
    key: 'passengers',
    label: 'Пассажиры',
    icon: <IconId size="16px" stroke="2" />,
    children: [
      withPerm('PERM_PERSON_READ', {
        key: 'passengers-all',
        label: (
          <Link to={appRoute.PERSONS.path}>
            <Badge status="default" text="Все пассажиры" />
          </Link>
        ),
      }),
      withPerm('PERM_PERSON_CREATE', {
        key: 'passengers-add',
        label: (
          <Link to={appRoute.PERSONS.ADD.path}>
            <Badge status="default" text="Добавить пассажира" />
          </Link>
        ),
      }),
    ],
  }),
  withPerm('PERM_JOURNAL_READ', {
    key: 'events',
    label: 'Журнал событий',
    icon: <IconList size="16px" stroke="2" />,
    children: [
      {
        key: 'events-all',
        label: (
          <Link to={appRoute.EVENTS.path}>
            <Badge status="default" text="Все события" />
          </Link>
        ),
      },
    ],
  }),
  withPerm('PERM_USER_READ', {
    key: 'users',
    label: 'Пользователи',
    icon: <IconUsers size="16px" stroke="2" />,
    children: [
      withPerm('PERM_USER_READ', {
        key: 'users-all',
        label: (
          <Link to={appRoute.USERS.path}>
            <Badge status="default" text="Все пользователи" />
          </Link>
        ),
      }),
      withPerm('PERM_USER_CREATE', {
        key: 'users-add',
        label: (
          <Link to={appRoute.USERS.ADD.path}>
            <Badge status="default" text="Добавить пользователя" />
          </Link>
        ),
      }),
      withPerm('PERM_USER_ROLE_READ', {
        key: 'roles-all',
        label: (
          <Link to={appRoute.ROLES.path}>
            <Badge status="default" text="Все роли" />
          </Link>
        ),
      }),
      withPerm('PERM_USER_ROLE_CREATE', {
        key: 'roles-add',
        label: (
          <Link to={appRoute.ROLES.ADD.path}>
            <Badge status="default" text="Добавить роль" />
          </Link>
        ),
      }),
    ],
  }),
  {
    key: 'terminals',
    icon: <IconDeviceTablet size="16px" stroke="2" />,
    label: <Link to={terminalsAppRoute.path}>Терминалы</Link>,
  },
];

const selectedKeys: string[] | undefined = [];
export const SideMenu = observer(
  ({ isCollapsed }: { isCollapsed: boolean }) => {
    const userProfileStore = useUserProfileStore();
    const withPerm = (perm: UPermissionsName, item: ItemType) =>
      userProfileStore.perms.has(perm) ? item : null;

    return (
      <Menu
        theme="light"
        mode="inline"
        defaultOpenKeys={isCollapsed ? [] : defaultOpenKeys}
        selectedKeys={selectedKeys}
        triggerSubMenuAction="click"
        items={menuItems({ withPerm })}
      >
        {/* <SubMenu
        key="tickets"
        title="Билеты"
        icon={<IconTicket size="16px" stroke="2" />}
        perm="PERM_PERSON_READ"
      >
        <MenuItem key="tickets-operations" perm="PERM_PERSON_READ">
          <Link to={appRoute.TICKETS.ORDERS.path}>
            <Badge status="default" text="Заказы" />
          </Link>
        </MenuItem>
        <MenuItem key="tickets-report" perm="PERM_PERSON_READ">
          <Link to={appRoute.TICKETS.REPORT.path}>
            <Badge status="default" text="Отчет" />
          </Link>
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="trips"
        title="Рейсы"
        icon={<IconCalendarTime size="16px" stroke="2" />}
        perm="PERM_PERSON_READ"
      >
        <MenuItem key="trips-all" perm="PERM_PERSON_READ">
          <Link to={appRoute.TRIPS.path}>
            <Badge status="default" text="Все рейсы" />
          </Link>
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="passengers"
        title="Пассажиры"
        icon={<IconId size="16px" stroke="2" />}
        perm="PERM_PERSON_READ"
      >
        <MenuItem key="passengers-all" perm="PERM_PERSON_READ">
          <Link to={appRoute.PERSONS.path}>
            <Badge status="default" text="Все пассажиры" />
          </Link>
        </MenuItem>
        <MenuItem key="passengers-add" perm="PERM_PERSON_CREATE">
          <Link to={appRoute.PERSONS.ADD.path}>
            <Badge status="default" text="Добавить пассажира" />
          </Link>
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="events"
        title="Журнал событий"
        icon={<IconList size="16px" stroke="2" />}
        perm="PERM_JOURNAL_READ"
      >
        <MenuItem key="events-all" perm="PERM_JOURNAL_READ">
          <Link to={appRoute.EVENTS.path}>
            <Badge status="default" text="Все события" />
          </Link>
        </MenuItem>
      </SubMenu>

      <SubMenu
        key="users"
        title="Пользователи"
        icon={<IconUsers size="16px" stroke="2" />}
        perm="PERM_USER_READ"
      >
        <MenuItem key="users-all" perm="PERM_USER_READ">
          <Link to={appRoute.USERS.path}>
            <Badge status="default" text="Все пользователи" />
          </Link>
        </MenuItem>

        <MenuItem key="users-create" perm="PERM_USER_CREATE">
          <Link to={appRoute.USERS.ADD.path}>
            <Badge status="default" text="Добавить пользователя" />
          </Link>
        </MenuItem>
      </SubMenu> */}
      </Menu>
    );
  },
);
